"use client";

import { trans } from "@/service/i18n/i18n";
import { Metadata } from "next";
import { createMetadata } from "@/service/seo/metadata";
import { Button } from "@/components/ui/button";
import { getAssetImage } from "@/service/image/asset";
import { SuperLink as Link } from "@/components/common/super-link";

export const dynamic = "force-dynamic";

export async function generateMetadata(): Promise<Metadata> {
  return createMetadata({
    title: "Błąd 500",
  });
}

async function Index() {
  return (
    <div className="flex flex-col items-center justify-center gap-8 py-16 text-center">
      <img
        src={getAssetImage("/error/500.png")}
        alt="500"
        className="h-auto w-64 md:w-96"
      />
      <h1 className="text-muted-foreground text-3xl font-semibold tracking-tight md:text-4xl">
        {trans("error.500")}
      </h1>
      <div className="flex flex-wrap items-center justify-center gap-4">
        <Button variant="blue" asChild>
          <Link href={"/"}>{trans("error.home")}</Link>
        </Button>
      </div>
    </div>
  );
}

export default Index;
